import * as React from 'react';
import classes from './ListItemContainer.module.scss';
import classNames from 'classnames';
import { WithChildren } from '../../../models/children-props';
import { Dispatch, SetStateAction, useRef } from 'react';
import { useDimensions } from '../../../hooks/useDimensions';
import { BreakpointsValuesEnum } from '../../../constants/breakpoints-values';
import { capitalize } from 'lodash';
import useWhatInput from 'react-use-what-input';

export type ListItemContainerViewProps = WithChildren & {
  //
  type: 'ul' | 'div';
  expanded: boolean;
  maxHeight?: number;
  contain?: boolean;
  setExpanded?: Dispatch<SetStateAction<boolean>>;
  isDrawer?: boolean;
};

export const ListItemContainerView = (props: ListItemContainerViewProps) => {
  const ItemTag = `${props.type}` as keyof Pick<JSX.IntrinsicElements, 'ul' | 'div'>;
  const nodeRef = React.useRef(null);
  const documentRef = useRef(document.body);
  const { height } = useDimensions(documentRef);
  const verticalType = height > BreakpointsValuesEnum.tabletportrait ? 'desktop' : 'mobile';
  const inputType = useWhatInput('intent');
  const listDropdownClasses = classNames(verticalType, classes.ListItemContainer, {
    'list-item-container': true, // legacy class for testing purposes
    [classes[`ListItemContainer${capitalize(verticalType)}`]]: props.maxHeight === undefined && props.expanded,
    [classes.ListItemContainerHidden]: !props.expanded,
    [classes.OpenFilter]: props.isDrawer && props.expanded && inputType !== 'touch',
    // ^adding visiblity hidden, to prevent flickering effect for portals. hidden elements still have height available,
    // thus we can calculate portal styles with no issues
    [classes.ListItemContainerContain]: props.contain,
    [classes.ListItemContainerMaximized]: props.maxHeight !== undefined,
    [classes.ListItemContainerIsDrawer]: props.isDrawer,
    ListItemContainerExpanded: props.expanded // legacy for tests
  });

  return (
    <ItemTag
      key={`list-item-${props.type}-${verticalType}`}
      className={listDropdownClasses}
      ref={nodeRef}
      {...(props.type === 'div' ? { role: 'list' } : {})}
      {...(typeof props.maxHeight === 'number'
        ? { style: { ...(props.expanded ? { maxHeight: props.maxHeight } : {}) } }
        : {})}>
      {props.children}
    </ItemTag>
  );
};
